import { render, staticRenderFns } from "./UnlockFiscalYear.vue?vue&type=template&id=0facfa96"
import script from "./UnlockFiscalYear.vue?vue&type=script&lang=js"
export * from "./UnlockFiscalYear.vue?vue&type=script&lang=js"
import style0 from "./UnlockFiscalYear.vue?vue&type=style&index=0&id=0facfa96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports